import { OnInit, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';
import { OpeningService } from '../../opening.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoRequisitionTracking } from 'app/shared/models/opening/dto-requisition-tracking.model';
import { ValidatorService } from 'app/shared/services/validator.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalRequisitionTrackingComponet } from 'app/views/modales/opening/requisition-tracking/modal-requisition-tracking.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { DatePipe } from '@angular/common';
import { DocumentService } from 'app/shared/services/document.service';
import { saveAs } from 'file-saver';
import { ModalUploadFilesComponet } from 'app/views/modales/opening/upload-files/modal-upload-files.component';

@Component({
    selector: '[requisition-tracking]',
    templateUrl: './requisition-tracking.template.html',
    styleUrls: ['./requisition-tracking.style.scss'], encapsulation: ViewEncapsulation.None
})
export class RequisitionTrackingComponent implements OnInit, OnChanges {
    /**Formularios */
    private formGeneralData: FormGroup;
    private formCandidate: FormGroup;
    /**Notificaciones */
    private configToast: any;
    /**Catalogos */
    private catalogSources: Observable<ISelect[]>;
    private catalogCandidates: IDtoCatalog[];
    private requisitionTrackings = new Array() as IDtoRequisitionTracking[];
    /**Inputs */
    @Input() private requisition: any;
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;
    private modalRef: BsModalRef;
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    private profile: string;
    private fileName = '';
    private document = {} as IDtoDocument;
    public constructor(private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private openingService: OpeningService
        , private recruitmentService: RecruitmentService
        , private configurationService: ConfigurationService
        , private identityService: IdentityService
        , private modalService: BsModalService
        , private router: Router
        , private route: ActivatedRoute
        , private securityService: SecurityService
        , private datePipe: DatePipe
        , private documentService: DocumentService) {
        this.initializeFormGerneralData();
        this.initializeFormCandidate();
        this.configToast = configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        if (this.configurationService.isReady) {
            this.catalogSources = this.recruitmentService.getCatalogSources();
            console.log('requisicion',this.requisition)
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.catalogSources = this.recruitmentService.getCatalogSources();
            });
        }
        this.profile = this.securityService.getProfileStorage('RequisitionReviews');
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.requisition.currentValue !== undefined && changes.requisition.currentValue !== null) {
            this.patchValueGeneralData();
            this.getRequisitionTrackingsByRequisitionId();
            this.getCandidatesRechargeableByRequisitionId();
            console.log('requisicion',this.requisition)
        }
  }
  private getCandidatesRechargeableByRequisitionId(){
    if (this.requisition.requisitionId == undefined) {
      return;
  }
  this.recruitmentService.getCandidatesRechargeableByRequisitionId(this.requisition.requisitionId).subscribe(e => {
    this.catalogCandidates = e;
  });
  }
    private initializeFormGerneralData() {
        this.formGeneralData = this.formBuilder.group({
            recruitingObservations: [null, [Validators.required, Validators.maxLength(500)]],
            recruitmentSourceId: [null, [Validators.required]],
            interviewObservations: [null, [Validators.required, Validators.maxLength(500)]],
            hireDate: [null, [Validators.required]],
            admissionDate: [null, [Validators.required]],
            finalRecruitmentObservation: [null, [Validators.required, Validators.maxLength(500)]]
        });
    }
    private initializeFormCandidate() {
        this.formCandidate = this.formBuilder.group({
            jobCandidateId: [null, [Validators.required]]
        });
    }
    private submitForm(form: FormGroup) {
        if (form.valid) {
            const value = form.value;
            this.requisition.recruitingObservations = value.recruitingObservations;
            this.requisition.recruitmentSourceId = value.recruitmentSourceId;
            this.requisition.interviewObservations = value.interviewObservations;
            this.requisition.hireDate = value.hireDate;
            this.requisition.admissionDate = value.admissionDate;
            this.requisition.statusRequestId = 2;
            this.requisition.finalRecruitmentObservation = value.finalRecruitmentObservation;
            if (this.requisition.requisitionId > 0) {
                this.updateRequisition();
            } else {
                this.addRequisition();
            }
        } else {
            this.snotifyService.error('Llene todos los datos para poder continuar'
                , 'Error', this.configToast);
            this.configGeneral.touchedControls(form);
        }
    }
    private addRequisitionTracking() {
        if (this.formCandidate.valid) {
            const values = this.formCandidate.value as IDtoRequisitionTracking;
            var exist = this.requisitionTrackings.some(item => item.jobCandidateId == values.jobCandidateId);
            if (exist) {
                this.configGeneral.newToast('Validación', 'El candidato seleccionado ya tiene un seguimiento asociado a esta requisición', 'error');
                return;
            }
            values.jobCandidate = this.catalogCandidates.filter(c => c.id == values.jobCandidateId)[0].name;
            values.requisitionId = this.requisition.requisitionId;
            values.trackingStatusId = '1';
            values.trackingStatus = 'Sin proceso';
            this.openingService.addRequisitionTracking(values).subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.configGeneral.newToast('Éxito', 'Registro guardado correctamente', 'success');
                        let res = x.data as IDtoRequisitionTracking;
                        values.id = res.id;
                        this.requisitionTrackings.push(values);
                        this.requisitionTrackings = [...this.requisitionTrackings];
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
        }
    }
    private deleteRequisitionTracking(dto:IDtoRequisitionTracking): void {
        this.openingService.deleteRequisitionTracking(dto.id).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.snotifyService.success('Registro eliminado correctamente'
                        , 'Éxito', this.configToast);
                        let index = this.requisitionTrackings.indexOf(dto)
                        if (index > -1) {
                            this.requisitionTrackings.splice(index, 1);
                            this.requisitionTrackings = [...this.requisitionTrackings];
                        }
                } else {
                    this.snotifyService.error(x.message
                        , 'Error', this.configToast);
                }
            },
            (errMessage) => this.errorMessages = errMessage.messages);
    }
    private getRequisitionTrackingsByRequisitionId(): void {
        if (this.requisition.requisitionId == undefined) {
            return;
        }
        this.openingService.getRequisitionTrackingsByRequisitionId(this.requisition.requisitionId).subscribe(
            (x) => {
                this.requisitionTrackings = x;
                console.log(this.requisitionTrackings)
            },
            (errMessage) => this.errorMessages = errMessage.messages);
    }
    private openModalRequisitionTracking(dto:IDtoRequisitionTracking) {
        const initialState = {
            requisitionTracking: dto,
            title: 'Seguimiento requisición para el candidato ' + dto.jobCandidate,
            profile: this.profile
        };
        this.modalRef = this.modalService.show(ModalRequisitionTrackingComponet
            , Object.assign({ initialState }
                , { class: 'modal-lg' }
                , this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                let index = this.requisitionTrackings.indexOf(dto)
                if (index > -1) {
                    this.requisitionTrackings.splice(index, 1);
                    this.requisitionTrackings.push(result);
                    this.requisitionTrackings = [...this.requisitionTrackings];
                }
            }
        });
    }
    private addRequisition(): void {
        this.openingService.addRequisition(this.requisition).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.snotifyService.success('Registro guardados correctamente'
                        , 'Éxito', this.configToast);
                    this.requisition = x.data as IDtoRequisition
                } else {
                    this.snotifyService.error(x.message
                        , 'Error', this.configToast);
                }
            },
            (errMessage) => this.errorMessages = errMessage.messages);
    }
    private updateRequisition(): void {
        this.openingService.updateRequisition(this.requisition).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.snotifyService.success('Registros actualizados correctamente'
                        , 'Éxito', this.configToast);
                    this.requisition = x.data as IDtoRequisition
                    this.addModuleLog();
                } else {
                    this.snotifyService.error(x.message
                        , 'Error', this.configToast);
                }
            },
            (errMessage) => this.errorMessages = errMessage.messages);
    }
    private patchValueGeneralData(): void {
        this.formGeneralData.patchValue(this.requisition);
    }
    private addModuleLog(): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Requisitions';
        dto.module = 'requisitionReviews';
        dto.action = 'tracking';
        dto.registryAffectedId = this.requisition.id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    private navigateToRequest(row: IDtoRequisitionTracking): void {
        this.router.navigate(['/recruitments/profile',
          { id: row.jobCandidateId, module: 'requisition'}], { relativeTo: this.route });
  }
  // private onFileChange(event) {
  //   event.value = '';
  // }
  // private handleFileInput(files: FileList, dto:IDtoRequisitionTracking) {
  //   //this.fileName = files.item(0).name;
  //   this.upload(files, dto);
  // }
  // private upload(files: FileList, dto:IDtoRequisitionTracking): void {
  //   if (files != undefined) {
  //       this.spinner.show();
  //       let document = {} as IDtoDocument;
  //       const fileName = files.item(0).name;
  //       let sp = fileName.split('.').pop();
  //       let fileNameNew = `${dto.jobCandidateId}_SeguimientoRequisición_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
  //       document.fileName = fileNameNew;
  //       this.fileName = fileNameNew;
  //       document.referenceId = dto.id;
  //       document.folder = 'Requisition';
  //       document.module = 'RequisitionTrackings';
  //       document.name = "SeguimientoRequisición";
  //       document.acceptDuplicate = true;
  //       const file = files.item(0);
  //       this.documentService.addDocument(document, file).subscribe((res) => {
  //           if (res.isCorrect === true) {
  //               this.configGeneral.newToast('Éxito', res.message, 'success');
  //               this.document = res.data as IDtoDocument;
  //               this.fileName = this.document.fileName;
  //               //this.addModuleLog(this.customer.id, 'addRequisitionTracking');
  //           } else {
  //               this.configGeneral.newToast('Error', res.message, 'error');
  //           }
  //           this.spinner.hide();
  //       },
  //       (errMessage) => {
  //           this.spinner.hide();
  //           this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
  //       });
  //   }
  // }

  // private downloadFile(id:number): void {
  //   this.documentService.downloadFile(id).subscribe((res) => {
  //       if (res.isCorrect === true) {
  //           const file = res.data as any;
  //           const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
  //           saveAs(blob, file.fileDownloadName);
  //           this.spinner.hide();
  //       } else {
  //           this.configGeneral.newToast('Error', res.message, 'error');
  //           this.spinner.hide();
  //       }
  //   },
  //   (errMessage) => {
  //       this.spinner.hide();
  //       this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
  //   });
  // }
  // private downloadProcess(dto:IDtoRequisitionTracking): void {
  //   this.documentService.getLatesDocumentVersion(dto.id, 'SeguimientoRequisición').subscribe(res => {
  //     this.document = res.data as IDtoDocument;
  //     if (this.document == undefined)
  //     {
  //       this.configGeneral.newToast('Validación', 'No tiene documento para descargar', 'error');
  //       return;
  //     };
  //     this.downloadFile(this.document.id);
  //   })
  // }
  private openModalUploadFile(dto:IDtoRequisitionTracking): void {
    const initialState = {
        title: 'Subir archivos',
        jobCandidateId: dto.jobCandidateId,
        id: dto.id,
        name: 'SeguimientoRequisición',
        folder: 'Requisition',
        module: 'RequisitionTrackings',
        type: 'UploadFile'
    };
    this.modalRef = this.modalService.show(ModalUploadFilesComponet
        , Object.assign({ initialState }
            , this.configGeneral.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
        if (result) {
        // this.submitSentApproval(result);
        }
    });
  }
  private openModalDownloadFile(dto:IDtoRequisitionTracking): void {
    const initialState = {
        title: 'Subir archivos',
        jobCandidateId: dto.jobCandidateId,
        id: dto.id,
        name: this.profile == 'Reclutamiento' ? 'SeguimientoRequisiciónOperacion' : 'SeguimientoRequisición',
        folder: 'Requisition',
        module: this.profile == 'Reclutamiento' ? 'RequisitionTrackingsOperation': 'RequisitionTrackings',
        type: 'DownloadFile'
    };
    this.modalRef = this.modalService.show(ModalUploadFilesComponet
        , Object.assign({ initialState }
            , this.configGeneral.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
        if (result) {
        // this.submitSentApproval(result);
        }
    });
  }
}
